<template>
    <div>
        <!-- Modal de detalles de compulsa -->
        <el-dialog class="licitacion__modal-mobile" title="Prorrogar Compulsa" :visible.sync="extendDateDialog" width="30%">
          <div style="text-align:center">
            <p>¿Desea notificar a los participantes de la compulsa?</p>
            <el-switch
              style="display: block; margin-top: 20px"
              v-model="checkBoxSendMail"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="Si"
              inactive-text="No">
            </el-switch>
          </div>
          <span slot="footer" class="dialog-footer">
            <div style="text-align:center">
              <el-button @click="extendDateDialog = false">Cancel</el-button>
              <el-button type="primary" @click="extendLicitacionDate(licitacion)">Confirmar</el-button>
            </div>
          </span>
        </el-dialog>
        <el-dialog :title="'Proceso de Compra'" :visible.sync="showModalLicitacion" v-if="licitacion" v-on:closed="resetLicitacion()" :close-on-click-modal="false" width="100%" :fullscreen="true" :lock-scroll="true">
            <div class="licitacion__body-mobile">
              <div v-if="!user.isProvider && !licitacionTerminada() && this.licitacion.status.idLicitacionStatus !== '4' && this.licitacion.status.idLicitacionStatus !== '3'" style="margin-bottom:50px">
                  <el-alert title="La compulsa de precio aún no ha finalizado" type="warning" :closable="false" description="No se mostrarán las propuestas hasta que la licitación finalice" show-icon>
                  </el-alert>
              </div>
              <div v-if="!user.isProvider && !licitacionTerminada() && this.licitacion.status.idLicitacionStatus === '4'" style="margin-bottom:20px">
                  <el-alert title="La compulsa de precio ha sido cancelada" type="error" :closable="false" description="No se podran enviar y/o editar mas propuestas" show-icon>
                  </el-alert>
              </div>
              <div style="margin-bottom: 50px" v-if="user.isProvider && this.licitacion.status.idLicitacionStatus === '3'">
                <el-alert title="La compulsa de precio ha finalizado" type="warning" :closable="false" description="No podrá enviar y/o editar una propuesta" show-icon> <!-- revisar -->
                </el-alert>
              </div>
              <div style="margin-bottom: 50px" v-if="!user.isProvider && this.licitacion.status.idLicitacionStatus === '3'">
                <el-alert title="La compulsa de precio ha finalizado" type="warning" description="No se podran enviar y/o editar mas propuestas" :closable="false" show-icon> <!-- revisar -->
                </el-alert>
              </div>
              <el-row>
              <p style="padding-right:30px;marginBottom:-15px; font-size:22px; color:#333333; font-weight:bold">{{licitacion.nombre}}</p>
                <el-col :span="18">
                  <p v-if="licitacion.codPO != null" style="font-size:13px; font-weight:bold; color:#5e6c84">Codigo: {{licitacion.codPO}}</p>
                  <el-divider></el-divider>
                  <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Descripción</span></el-divider>
                  <p style="text-align: justify; text-justify: auto; word-break: keep-all; marginTop:25px" v-html="licitacion.cuerpo"></p>
                </el-col>
                <el-col :span="4" style="margin-left:5%" v-if="licitacion">
                  <p style="font-size:12px; color:#5e6c84">ESTADO</p>
                  <p style="color:#172b4d">{{licitacion.status.descripcion}}</p>
                  <p style="font-size:12px; margin-top: 25px; color:#5e6c84; word-break: keep-all">FECHA DE INICIO</p>
                  <p style="font-size:15px; color:#172b4d">{{licitacion.fecha_inicio}}</p>
                  <p style="font-size:12px; margin-top: 25px; word-break: keep-all; color:#5e6c84">FECHA DE FINALIZACIÓN</p>
                  <p style="font-size:15px; color:#172b4d">{{licitacion.fecha_fin}}</p>
                  <p style="font-size:12px; margin-top: 25px; color:#5e6c84">SUPERVISOR</p>
                  <div v-if="licitacion.supervisor != null">
                    <p style="font-size:15px; color:#172b4d">{{licitacion.supervisorName}}</p>
                  </div>
                  <p style="font-size:12px; margin-top: 25px; color:#5e6c84">RESPONSABLES</p>
                    <span style="font-size:15px; color:#172b4d; text-align: justify; text-justify: auto; word-break: keep-all" v-for="(manager, index) in licitacion.buyersNames" :key="manager">
                      <span v-if="index == licitacion.buyersNames.length - 1">{{manager}}</span>
                      <span v-else>{{manager}}, </span>
                    </span>
                  <div v-if="licitacion.buyers.length <= 0">
                    <p>-</p>
                  </div>
                  <div v-if="!user.isProvider">
                    <p style="font-size:12px; margin-top: 25px; color:#5e6c84">OFERTAS PRESENTADAS</p>
                    <p style="word-break: keep-all;">{{offerAmount}}/{{licitacion.proveedores.length}}</p>
                  </div>
                  <div v-if="!user.isProvider && !licitacionTerminada()">
                    <el-date-picker
                      style="margin-top: 20px; width: 188px"
                      v-model="extensionDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="Seleccionar fecha"
                      :picker-options="{disabledDate(date) { return pastDateToday(date) }}">
                    </el-date-picker>
                    <el-button type="primary" @click="extendDateDialog = true" :disabled="extensionDate === null" style="margin-top: 5px;" icon="el-icon-timer">Prorrogar Compulsa</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin-top:50px; margin-right:-1%">
                <el-col :span="18">
                <el-divider  content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d; font-weight:bold">Archivos de la compulsa</span></el-divider>
                  <div>
                    <el-table :data="licitacion.documents" style="width: 100%" height="auto">
                      <el-table-column prop="comment" label="Comentario" width="180">
                      </el-table-column>
                      <el-table-column prop="date" label="Fecha">
                      </el-table-column>
                      <el-table-column label="PDF">
                        <template slot-scope="scope">
                          <a :href="scope.row.url" target="_blank">
                            <el-button type="primary" icon="el-icon-document" circle></el-button>
                          </a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
                <div v-if="!user.isProvider && !licitacionTerminada()">
                    <el-col :span="4" :offset="1" style="margin-top:5%">
                    <div>
                      <span style="color:#5e6c84;">Adjuntar un documento</span>
                    </div>
                    <div>
                        <el-input
                          type="textarea"
                          :rows="2"
                          placeholder="Inserte comentario"
                          v-model="documentComment"
                          style="width:70%; margin-top:10px">
                        </el-input>
                        <el-upload
                          :limit="1"
                          style="margin-top:10px;"
                          ref="upload"
                          class="upload-demo"
                          accept= "application/pdf"
                          :action="serverURI + 'api/uploadFile'"
                          :auto-upload="false"
                          :on-success="handlePdfCompulsa"
                          multiple
                          :show-file-list = "true"
                          :data="{
                                folder: 'documentsCompulsa'
                          }">
                          <el-button slot="trigger" size="small" type="primary">Seleccionar documento</el-button>
                          <el-button size="small" type="success" @click="submitUpload">Subir</el-button>
                        </el-upload>
                    </div>
                    </el-col>
                  </div>
                  </el-row>
                <el-col :span="24" style="margin-top:50px"><!-- Ofertas -->
                  <div v-if="!user.isProvider && licitacionTerminada()" style="font-size: 14px; color:#172b4d; font-weight:bold">Oferta<span v-if="!user.isProvider">s</span> </div>
                  <table class="table" style="font-size: 15px" v-if="user.isProvider && licitacion.status.idLicitacionStatus === '2'">
                      <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Ofertas</span></el-divider>
                      <tr style="margin-top:100px">
                          <th width="20%">Oferta técnica</th>
                          <td width="60%">
                              <input v-if="!licitacion.oferta_tec || editTec" type="file" ref="fileOfertaTec"  accept="application/pdf" class="form-control-file" style="width:80%; float: left;font-size:14px" data-cy="oferta-tecnica" @change="uploadOferta('tec')">
                              <div v-else>
                                <a :href="licitacion.oferta_tec" target="_blank" style="padding-right: 20px">
                                  <i class="fa fa-file-pdf-o"/> PDF
                                </a>
                                <el-button type="primary" v-if="licitacion.visto !== '2'" icon="el-icon-edit" @click="editTec = true">Editar</el-button>
                              </div>
                          </td>
                      </tr>
                      <tr style="height: 70px">
                          <th width="20%">Oferta económica</th>
                          <td width="60%">
                              <input v-if="!licitacion.oferta_eco || editEco" type="file" ref="fileOfertaEco" accept="application/pdf" class="form-control-file" style="width:80%; float: left;font-size:14px" data-cy="oferta-economica" @change="uploadOferta('eco')">
                              <div v-else >
                                <a :href="licitacion.oferta_eco" target="_blank" style="padding-right: 20px">
                                  <i class="fa fa-file-pdf-o"/> PDF
                                </a>
                                <el-button type="primary" v-if="licitacion.visto !== '2'" icon="el-icon-edit" @click="editEco = true">Editar</el-button>
                              </div>
                          </td>
                      </tr>
                      <br>
                      <tr>
                        <th width="20%">
                        </th>
                        <tr width="100%">
                          <el-button v-if="showUpload" @click="uploadOfertas" type="primary" style="float:left;margin-bottom:50px" icon="el-icon-upload">
                            Subir ofertas
                          </el-button>
                          <el-button v-if="showUpload && canConfirm" @click="confirmOfertas" type="success" style="margin-left:6%;margin-bottom:50px" icon="el-icon-check">
                            Confirmar Oferta
                          </el-button>
                        </tr>
                      </tr>
                      <el-divider></el-divider>
                  </table>
                  <div v-if="!user.isProvider && licitacion.status.idLicitacionStatus === '3'">
                      <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Ofertas de los Proveedores</span></el-divider>
                      <data-tables :data="licitacion.propuestas" :pagination-props="{ pageSizes: [5, 10, 15] }" >
                          <el-table-column v-for="title in propuestasTable" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                          </el-table-column>
                          <el-table-column label="Oferta Técnica">
                            <template slot-scope="scope">
                              <a :href="scope.row.oferta_tec" target="_blank" style="padding-right: 20px">
                                <i class="fa fa-file-pdf-o"/> PDF
                              </a>
                            </template>
                          </el-table-column>
                          <el-table-column label="Oferta Económica">
                            <template slot-scope="scope">
                              <a :href="scope.row.oferta_eco" target="_blank" style="padding-right: 20px">
                                <i class="fa fa-file-pdf-o"/> PDF
                              </a>
                            </template>
                          </el-table-column>
                      </data-tables>
                  </div>
                </el-col>
              </el-row>
              <div>
            </div>
                <!-- Consultas en modal Detalles Para el proveedor -->
                <div v-if="user.isProvider">
                    <div v-if="!licitacionTerminada()">
                      <div style="color:black;font-size: 14px ;font-weight:bold;margin-left:15px;margin-bottom:15px">
                        Nueva consulta</div>
                      <div class="entrada"><!-- Reemplazar por tabla -->
                          <div>
                            <el-input type="textarea" required placeholder="Consulta" v-model="newQuestion" :rows="3" :resize="'vertical'" style="margin-left: 10px"></el-input>
                            <div style="text-align: right">
                              <br>
                              <button class="btn btn-primary" v-on:click="sendConsulta(null, 0, 2)">
                                  Enviar Consulta
                              </button>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="col-md-12" style="font-size: 20px; color: #303133;">
                        <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Tus consultas</span></el-divider>
                        <el-alert style="margin-bottom: 20px" v-if="queries.length == 0" title="No hay consultas" type="warning" :closable="false" description="Aun no has hecho ninguna consulta." show-icon>
                        </el-alert>
                        <el-collapse v-model="activeQuestions">
                            <el-collapse-item :name="item.idMessage" v-for="item in questions" :key="item.idMessage">
                                <template slot="title">
                                    <span style="font-weight: bold;">{{ item.message }}</span>
                                </template>
                                <div style="padding-left: 20px;" v-if="item.answer"><i class="far fa-comment-dots" /> {{ item.message }} </div>
                                <div style="padding-left: 20px;" v-if="!item.answer">Aun no hay respuesta para esta consulta</div>
                            </el-collapse-item>
                        </el-collapse>
                        <el-table v-if="queries.length > 0" :data="queries" :default-expand-all="true" :show-header="false" height="400px" style="width: 100%; margin-bottom: 50px">
                          <el-table-column type="expand">
                            <template slot-scope="props">
                              <p>{{ props.row.respuesta.message }}</p>
                              <div style="margin-left: 3%; font-size:12px" v-if="props.row.respuesta.message == ''">
                                <b>Esta consulta aun no tiene respuesta</b>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column min-width="400" prop="message"></el-table-column>
                          <el-table-column prop="date"></el-table-column>
                        </el-table>
                    </div>
                    <div class="col-md-12" style="font-size: 20px; color: #303133;padding-bottom: 100px">
                        <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Consultas Frecuentes</span></el-divider>
                        <el-alert v-if="FAQ.length == 0" title="No hay consultas frecuentes" type="warning" :closable="false" description="Aun no se ha marcado ninguna pregunta como frecuente." show-icon>
                        </el-alert>
                        <el-table v-if="FAQ.length > 0" :data="FAQ" :default-expand-all="true" :show-header="false" height="400px" style="width: 100%">
                          <el-table-column type="expand">
                            <template slot-scope="props">
                              <p>{{ props.row.respuesta.message }}</p>
                            </template>
                          </el-table-column>
                          <el-table-column min-width="400" prop="message"></el-table-column>
                          <el-table-column prop="date"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <!-- Consultas en modal Detalles Para el usuario de compras -->
                <div v-if="!user.isProvider" style="margin-top: 2%">
                        <span v-if="queries.length > 0" style="padding-left: 10px; font-size: 20px; color: #303133;"><el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Consultas</span></el-divider></span>
                        <span v-if="queries.length === 0" style="padding-left: 10px; font-size: 20px; color: #303133;"><el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d"></span></el-divider></span>
                        <!-- <el-collapse style="padding-bottom: 20px">
                            <el-collapse-item :name="item.idMessage" v-for="item in queries" :key="item.idMessage">
                                <template slot="title">
                                    <span style="font-weight: bold;">{{ item.message }} <i class="fa fa-envelope" v-if="!item.respuesta"/></span>
                                      <el-button style="margin-left: 90px" type="danger" size="mini" round @click="deleteLicitacionesConsulta(item.respuesta)">Eliminar</el-button>
                                </template>
                        -->
                        <el-table v-if="queries.length > 0" :data="queries" :default-expand-all="true" :show-header="false" height="400px" style="width: 100%; margin-bottom: 50px">
                          <el-table-column min-width="300" prop="message"></el-table-column>
                          <el-table-column min-width="50" prop="name"></el-table-column>
                          <el-table-column width="60">
                            <template slot-scope="props">
                              <el-tooltip class="item" effect="dark" content="Consulta Frecuente" placement="left-start" v-if="props.row.respuesta.message != ''">
                                <el-switch
                                  @change="actualizarTipoConsulta(props.row)"
                                  v-model="props.row.messageType"
                                  active-value="1"
                                  inactive-value="2">
                                </el-switch>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="date"></el-table-column>
                          <el-table-column type="expand">
                            <template slot-scope="props">
                              <p>{{ props.row.respuesta.message }}</p>
                              <p style="float:right">{{ props.row.respuesta.name }}</p>
                              <div v-if="props.row.respuesta.message == ''">
                                <el-input type="textarea" required placeholder="Respuesta" v-model="respuestas[props.row.idMessage]" :rows="3" :resize="'none'"></el-input>
                                <button class="btn btn-primary" v-on:click="sendAnswer(props.row.idMessage, props.row.idEmisor, respuestas[props.row.idMessage], props.row)" style="float:right">Enviar Respuesta</button>
                              </div>
                              <!-- <el-button style="margin-left: 90px" type="danger" size="mini" round @click="deleteLicitacionesConsulta(item.respuesta)">Eliminar</el-button> -->
                            </template>
                          </el-table-column>
                        </el-table>
                        <div>
                        <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d;">Consultas Frecuentes</span></el-divider>
                        </div>
                        <el-alert v-if="FAQ.length == 0" title="No hay consultas frecuentes" type="warning" :closable="false" description="Aun no se ha marcado ninguna pregunta como frecuente." show-icon>
                        </el-alert>
                        <el-table v-if="FAQ.length > 0" :data="FAQ" :default-expand-all="true" :show-header="false" height="400px" style="width: 100%">
                          <el-table-column min-width="250" prop="message"></el-table-column>
                          <el-table-column width="180" >
                            <template slot-scope="props">
                              <el-tooltip class="item" effect="dark" content="Eliminar Consulta" placement="left-start">
                                <el-button style="margin-left: 90px" type="danger" size="mini" round @click="deleteLicitacionesConsulta(props.row)">Eliminar</el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column width="60" >
                            <template slot-scope="props">
                              <el-tooltip class="item" effect="dark" content="Consulta Frecuente" placement="left-start" v-if="props.row.idEmisor !== '1'">
                                <el-switch
                                  @change="actualizarTipoConsulta(props.row)"
                                  v-model="props.row.messageType"
                                  active-value="1"
                                  inactive-value="2">
                                </el-switch>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="date"></el-table-column>
                          <el-table-column type="expand">
                            <template slot-scope="props">
                              <p>{{ props.row.respuesta.message }}</p>
                            </template>
                          </el-table-column>
                        </el-table>
                </div>
                <div v-if="!user.isProvider && !licitacionTerminada()" style="margin-bottom:50px">
                  <el-divider content-position="left"><span style="font-size:14px; font-weight:bold; color:#172b4d">Crear nuevas consultas frecuentes</span></el-divider>
                  <el-input style="margin-bottom:25px;margin-top:10px" type="textarea" required placeholder="Pregunta" v-model="newQuestion" :rows="4" :resize="'none'"></el-input>
                  <div class="col-md-9">
                    <el-input style="margin-left:-15px" type="textarea" required placeholder="Respuesta" v-model="respuestaFrecuente" :rows="3" :resize="'none'"></el-input>
                  </div>
                  <button class="btn btn-primary" v-on:click="sendConsultaFrecuente()" style="margin-top: 20px; margin-bottom: 50px">
                      Agregar pregunta frecuente
                  </button>
                </div>
            </div>

        </el-dialog>

        <!--
      Modal para ver o agregar si aun no lo estan, a los proveedores que participaran de la licitacion.
    -->
        <el-dialog :title="'Proveedores de la compulsa ' + licitacion.nombre" :visible.sync="showModalLicitacionProviders" v-if="providers && !user.isProvider && licitacion" v-on:closed="licitacion = ''" :fullscreen="true" :lock-scroll="true">
            <div style="margin-bottom: 10px;">
                <el-row>
                    <el-col :span="7" :xs="24" >
                        <el-select class="provider__select-mobile" clearable placeholder="Rubro" multiple v-model="filtersRubro[0].value">
                            <el-option v-for="(item,index) in rubros" :key="item.idRubro" :value="item.idRubro + index" :label="item.nombre"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="6" :xs="24">
                        <el-input placeholder="Identificación Fiscal / Nombre" v-model="filtersRubro[1].value"></el-input>
                    </el-col>
                </el-row>
            </div>
            <data-tables :data="providersParaCompulsa" class="table-responsive licitaciones__table-mobile" :pagination-props="{ pageSizes: [10, 20, 30] }" :filters="filtersRubro">
                <el-table-column width="55" v-if="needProviders(licitacion)">
                    <template slot-scope="scope">
                        <input type="checkbox" v-model="providersSelected" :value="scope.row.idCompany" />
                    </template>
                </el-table-column>
                <el-table-column property="fiscalId" label="Id Fiscal">
                </el-table-column>
                <el-table-column property="idType" label="Id Tipo">
                </el-table-column>
                <el-table-column label="Proveedor">
                  <template slot-scope="scope">
                    {{getCompanyName(scope.row)}}
                  </template>
                </el-table-column>
                <el-table-column label="Rubros">
                    <template slot-scope="scope">
                        <span v-for="(rubro, index) in scope.row.rubros" :key="rubro.idRubro + index">
                          {{rubro.nombre}}
                          <span v-if="(index + 1) < scope.row.rubros.length">
                            /
                          </span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Calificación">
                    <template slot-scope="scope">
                      <span style="display:none">{{scope.row.calification = Number(scope.row.calification)}}</span>
                        <el-rate v-model="scope.row.calification" disabled></el-rate> <!-- v-model="scope.row.calification" -->
                    </template>
                </el-table-column>
            </data-tables>

          <div v-if="needProviders(licitacion)" class="licitacion__buttons-mobile">
            <button class="btn btn-secondary licitacion__button-mobile" style="float: left;" @click="providersSelected = []">
              Limpiar selección
            </button>
            <button class="btn btn-primary licitacion__button-mobile" style="float: left;" @click="guardarProveedores">
              Guardar proveedores
            </button>
            <button class="btn btn-primary licitacion__button-mobile" style="float: left;" :disabled="providersSelected.length === 0" @click="invitarProviders">
              Invitar proveedor<span v-if="providersSelected.length > 1">es ({{ providersSelected.length }})</span>
            </button>
          </div>
          <button class="btn btn-primary licitacion__accept-mobile" style="float: right" @click="showModalLicitacionProviders = false">
              Aceptar
          </button>

        </el-dialog>

    <section class="content">
        <el-dialog title="Agregar una compulsa" :visible.sync="showModal" width="90%" :lock-scroll="false" v-on:close="resetLicitacion()" max-width="500px">
            <div class="col-sm-12 entrada">
                <div class="col-sm-3">
                    <label class="licitacion__input-mobile">Nombre</label>
                </div>
                <div class="col-sm-9">
                    <el-input type="text" required placeholder="Nombre" v-model="licitacionNueva.nombre"></el-input>
                </div>
            </div>
            <div class="col-sm-12 entrada">
                <div class="col-sm-3">
                    <label class="licitacion__input-mobile">Descripción</label>
                </div>
                <div class="col-sm-9">
                    <vue-editor v-model="licitacionNueva.cuerpo"></vue-editor>
                </div>
            </div>
            <div class="col-sm-12 entrada">
                <div class="col-sm-3">
                    <label class="licitacion__input-mobile">Fecha de inicio</label>
                </div>
                <div class="col-sm-9" v-if="!editing">
                  <el-date-picker
                  class="licitacion__date-mobile"
                    v-model="licitacionNueva.fecha_inicio"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="Seleccionar fecha inicio"
                    :picker-options="{disabledDate(date) { return pastDateToday(date) }}"
                    @change="checkFinalDate()">
                  </el-date-picker>
                </div>
                <div v-else class="col-sm-9" style="margin-top: 10px;" >
                  {{ licitacionNueva.fecha_inicio }}
                </div>
            </div>
            <div class="col-sm-12 entrada">
                <div class="col-sm-3">
                    <label class="licitacion__input-mobile">Fecha de finalización</label>
                </div>
                <div class="col-sm-9" v-if="!editing">
                  <el-date-picker
                  class="licitacion__date-mobile"
                    v-model="licitacionNueva.fecha_fin"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="Seleccionar fecha finalizacion"
                    :picker-options="{disabledDate(date) {
                      if(date!==null){
                      return pastDateInitialDate(date) || pastDateToday(date)
                      }
                      }}"
                      >
                  </el-date-picker>
                </div>
                <div v-else class="col-sm-9" style="margin-top: 10px;" >
                  {{ licitacionNueva.fecha_inicio }}
                </div>
            </div>
             <div class="col-sm-12 entrada">
                 <div class="col-sm-3">
                     <label class="licitacion__input-mobile">Comprador</label>
                 </div>
                 <div class="col-sm-9">
                  <el-select class="licitacion__select-mobile" v-model="currentIdBuyer" required multiple placeholder="Seleccionar Comprador">
                    <el-option v-for="item in buyers.userJobs" :key="item.idUser" :value="item.idUser" :label="item.name"></el-option>
                  </el-select>
                 </div>
             </div>
             <div class="col-sm-12 entrada">
                 <div class="col-sm-3">
                     <label class="licitacion__input-mobile">Supervisor</label>
                 </div>
                 <div class="col-sm-9">
                  <el-select class="licitacion__select-mobile" v-model="licitacionNueva.supervisor" required  placeholder="Seleccionar Supervisor">
                    <el-option v-for="item in boss.userJobs" :key="item.idUser" :value="item.idUser" :label="item.name"></el-option>
                  </el-select>
                 </div>
             </div>
            <div class="col-sm-12 entrada">
                <el-alert type="error" v-if="licitacionAlert" :closable="false" show-icon>
                    <ul style="margin-left: 30px;">
                        <li v-for="(error, index) in erroresLicitacion" v-bind:key="index">
                            {{error}}
                        </li>
                    </ul>
                </el-alert>
            </div>
            <span slot="footer" class="dialog-footer">
          <button class="btn btn-primary" v-on:click="guardarLicitacion()">
            Guardar
          </button>
          <button class="btn" v-on:click="hideModal()">
            Cancelar
          </button>
          </span>
        </el-dialog>

        <div class="box-body">
            <div class="">
                <div style="margin-bottom: 10px">
                    <el-row>
                        <el-col :span="6" :xs="24" v-if="!user.isProvider">
                            <el-button style="margin-bottom: 10px;" @click="openModal()" type="primary" icon="el-icon-plus">Agregar</el-button>
                        </el-col>
                        <el-col :span="7" :xs="24" >
                            <el-input class="provider__select-mobile" v-model="filters[0].value" placeholder="Buscar"></el-input>
                        </el-col>
                        <el-col :span="8" :xs="24">
                          <el-select class="provider__select-mobile" multiple v-model="filters[1].value" placeholder="Estado">
                            <el-option
                              v-for="item in licitacionesStatus"
                              :key="item.idLicitacionStatus"
                              :value="item.descripcion"
                              :label="item.descripcion">
                            </el-option>
                          </el-select>
                        </el-col>
                    </el-row>
                </div>
                <data-tables class="licitaciones__table-mobile" :data="licitaciones" :pagination-props="{ pageSizes: [10, 20, 30] }" :filters="filters">

                    <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
                    </el-table-column>
                    <el-table-column label="Actividad">
                        <template slot-scope="scope">
                            {{ scope.row.status.descripcion }}
                        </template>
                    </el-table-column>

                    <el-table-column v-if="user.isProvider" label="Estado" :align="'center'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.visto === '0'"> Invitado </span>
                            <span v-if="scope.row.visto === '1'"> Visto </span>
                            <span v-if="scope.row.visto === '2'"> Enviado </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" :align="'center'" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" v-if="!user.isProvider" effect="dark" content="Consultas a responder" placement="top-end">
                              <el-badge :value="questionsWithoutResponse(scope.row)" class="item">
                                <el-button disabled type="warning" size="mini" style="cursor:default" icon="el-icon-bell" circle></el-button>
                              </el-badge>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="Detalles" placement="top-end">
                                <el-button type="primary" icon="el-icon-view" circle @click="seeDetails(scope.row)"></el-button>
                            </el-tooltip>

                            <el-tooltip v-if="!user.isProvider" class="item" effect="dark" v-bind:content="needProviders(scope.row) ? 'Agregar proveedores' : 'Ver proveedores'" placement="top-start">
                                <el-button v-bind:type="needProviders(scope.row) ? 'success' : 'info'" v-bind:icon="needProviders(scope.row) ? 'el-icon-plus' : 'fa fa-user'" circle @click="seeProviders(scope.row)"></el-button>
                            </el-tooltip>
                            <el-tooltip v-if="!user.isProvider && scope.row.status.idLicitacionStatus !== '1' && scope.row.status.idLicitacionStatus !== '4'" class="item" effect="dark" content="Cancelar compulsa" placement="top-start">
                                <el-button type="danger" icon="el-icon-video-pause" circle @click="cancelarLicitacion(scope.row)"></el-button>
                            </el-tooltip>
                            <el-tooltip v-if="!user.isProvider && scope.row.status.idLicitacionStatus == '1' && scope.row.status.idLicitacionStatus !== '4'" class="item" effect="dark" content="Borrar compulsa" placement="top-start">
                                <el-button type="danger" icon="el-icon-delete" circle @click="borrarLicitacion(scope.row)"></el-button>
                            </el-tooltip>
                            <!--
                            <el-tooltip v-if="user.isProvider" class="item" effect="dark" content="Preguntas Frecuentes" placement="top-start">
                                <el-button type="warning" icon="fa fa-question-circle" circle @click="seeFAQ(scope.row)"></el-button>
                            </el-tooltip>-->
                        </template>
                    </el-table-column>
                </data-tables>
            </div>
        </div>
    </section>
    </div>
</template>
<script>
  require('moment')
  import datepicker from 'vue-date-picker'
  import Vue from 'vue'
  import api from '../../api'
  import ElementUI from 'element-ui'
  import DataTables from 'vue-data-tables'
  import 'element-ui/lib/theme-chalk/index.css'
  import lang from 'element-ui/lib/locale/lang/es'
  import locale from 'element-ui/lib/locale'
  import { mapState } from 'vuex'
  import { VueEditor } from 'vue2-editor'
  import config from '../../config'

  Vue.use(ElementUI)
  locale.use(lang)
  Vue.use(DataTables)

  export default {
    name: 'Settings',
    components: {
      datepicker,
      VueEditor
    },
    data (router) {
      return {
        licitacionesStatus: [],
        section: 'Licitaciones',
        loading: '',
        licitacionNueva: {
          'nombre': '',
          'cuerpo': '',
          'fecha_inicio': '',
          'fecha_fin': '',
          'supervisor': ''
        },
        newQuestion: '',
        newAnswer: '',
        respuestas: {},
        extensionDate: null,
        documentComment: '',
        showFileList: false,
        questions: '',
        respuestaFrecuente: '',
        queries: [],
        FAQ: [],
        currentIdBuyer: [],
        buyers: [],
        boss: [],
        esConsultaFrecuente: 0,
        licitacionAlert: false,
        showModalLicitacion: false,
        showModalLicitacionProviders: false,
        showModalFAQ: false,
        licitacion: '',
        erroresLicitacion: [],
        rubros: [],
        showModal: false,
        serverURI: config.serverURI,
        activeQuestions: ['1', '2', '3'],
        editing: false,
        editTec: false,
        editEco: false,
        needUpload: false,
        canConfirm: false,
        extendDateDialog: false,
        checkBoxSendMail: false,
        providersParaCompulsa: [],
        offerAmount: 0,
        providersSelected: [],
        propuestasTable: [
          {
            prop: 'idProvider',
            label: 'Proveedor'
          },
          {
            prop: 'fecha_carga',
            label: 'Fecha carga'
          }
        ],
        titles: [{                      // Columnas que se van a mostrar
          prop: 'nombre',
          label: 'Nombre'
        },
        {
          prop: 'fecha_creacion',
          label: 'Fecha creación'
        },
        {
          prop: 'fecha_inicio',
          label: 'Inicio'
        },
        {
          prop: 'fecha_fin',
          label: 'Fin'
        }],
        filtersLic: [
          {
            prop: ['idProvider'],
            value: ''
          }],
        filtersRubro: [
          {
            prop: ['idRubro'],
            value: '',
            filterFn: (row, filterItem) => {
              return row.rubros.some(el => filterItem.value.includes(el.idRubro))
            }
          },
          {
            prop: ['cuit', 'companyName'],
            value: ''
          }
        ],
        filters: [
          {
            prop: ['nombre'],
            value: ''
          },
          {
            prop: ['status'],
            value: '',
            filterFn: (row, filterItem) => {
              return filterItem.value.includes(row.status.descripcion)
            }
          }],
        providers: []
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      datetime () {
        return new Date()
      },
      cerroLicitacion () {
        return new Date(this.licitacion.fecha_fin).getTime() <= this.datetime.getTime()
      },
      contacts () {
        return this.$store.state.contacts
      },
      licitaciones () {
        return this.$store.state.compulsas
      },
      showUpload () {
        return this.licitacion.visto !== '2' && (/* this.needUpload && */(this.licitacion.oferta_tec && !this.editTec || (this.$refs.fileOfertaTec && this.$refs.fileOfertaTec.files.length > 0)) && (this.licitacion.oferta_eco && !this.editEco || (this.$refs.fileOfertaEco && this.$refs.fileOfertaEco.files.length > 0)))
      }
    },
    mounted () {
      if (this.$route.params.licitacion) {
        this.licitacion = this.$route.params.licitacion
        this.seeDetails(this.licitacion)
      }
    },
    methods: {
      getCompanyName (row) {
        return row.companyName === '' ? row.company : row.companyName
      },
      submitUpload () {
        this.$refs.upload.submit()
      },
      handlePdfCompulsa (response, file, fileList) {
        api.request('POST', 'api/generic/licitacionesDocumentos', JSON.stringify({'idLicitacion': this.licitacion.idLicitacion, 'url': response, comment: this.documentComment}))
        .then(response => {
          api.request('GET', 'api/generic/licitacionesDocumentos/' + response.data.idDocument)
          .then(response => {
            let document = {idLicitacion: this.licitacion.idLicitacion, url: response.data.url, date: response.data.date, comment: this.documentComment}
            this.licitacion.documents.push(document)
            this.documentComment = ''
          })
        })
        this.$refs.upload.clearFiles()
        this.$message({
          message: 'El documento se ha subido correctamente.',
          type: 'success'
        })
      },
      questionsWithoutResponse (row) {
        let consultas = row.consultas.filter(consulta => consulta.replyTo === null).length
        let respuestas = row.consultas.filter(consulta => consulta.replyTo !== null).length
        return consultas - respuestas
      },
      openModal () {
        this.showModal = true
        this.editing = false
      },
      uploadOferta (type) {
        let formData = new FormData()
        formData.append('folder', 'licitacionesOfertas')
        if (type === 'tec') {
          formData.append('file', this.$refs.fileOfertaTec.files[0])
          api.request('POST', 'api/uploadFile', formData)
          .then(ofertaTec => {
            this.licitacion.oferta_tec = ofertaTec.data
            this.editTec = false
            api.request('POST', 'api/crearOferta', {'idLicitacion': this.licitacion.idLicitacion, 'provider': this.user.idProvider, 'pdf': this.licitacion.oferta_tec, 'oferta': type})
          })
        } else if (type === 'eco') {
          formData.append('file', this.$refs.fileOfertaEco.files[0])
          api.request('POST', 'api/uploadFile', formData)
          .then(ofertaEco => {
            this.licitacion.oferta_eco = ofertaEco.data
            this.editEco = false
            api.request('POST', 'api/crearOferta', {'idLicitacion': this.licitacion.idLicitacion, 'provider': this.user.idProvider, 'pdf': ofertaEco.data, 'oferta': type})
          })
        }
        this.needUpload = true
      },
      getLicitacionesStatus () {
        api.request('GET', 'api/generic/licitacionesStatus')
        .then(response => {
          this.licitacionesStatus = response.data
        })
      },
      pastDateToday (date) {
        return !(date.getTime() > Date.now() - 24 * 60 * 60 * 1000)
      },
      pastDateInitialDate (date) {
        return !(date.getTime() > new Date(this.licitacionNueva.fecha_inicio))
      },
      checkFinalDate () {
        if (this.licitacionNueva.fecha_fin && new Date(this.licitacionNueva.fecha_inicio) > new Date(this.licitacionNueva.fecha_fin)) {
          this.licitacionNueva.fecha_fin = new Date(this.licitacionNueva.fecha_inicio)
        }
      },
      extendLicitacionDate (licitacion) {
        if (licitacion.status.descripcion === 'Cancelada') {
          this.$message({
            type: 'error',
            message: 'No puede prorrogar una compulsa cancelada'
          })
          return
        } else {
          api.request('POST', 'api/generic/licitaciones/' + licitacion.idLicitacion, {'fecha_fin': this.extensionDate})
            .then(() => {
              this.licitacion.fecha_fin = this.extensionDate
              if (this.checkBoxSendMail) {
                licitacion.proveedores.forEach(provider => {
                  api.request('GET', 'api/sendMailExtendedDateCompulsa/' + provider.idProvider)
                })
              }
              this.$parent.getLicitaciones()
              this.extensionDate = ''
            })
          this.extendDateDialog = false
        }
      },
      licitacionTerminada () {
        //  return new Date(this.licitacion.fecha_fin).getTime() <= this.datetime.getTime()
        return this.licitacion.idLicitacionStatus === '4' || this.licitacion.idLicitacionStatus === '3'
      },
      recargarDetalles () {
        this.$parent.getLicitaciones()
          .then(() => {
            this.licitacion = this.licitaciones.find(el => el.idLicitacion === this.licitacion.idLicitacion)
            this.seeDetails(this.licitacion)
          })
      },
      actualizarTipoConsulta (consulta) {
        const messageType = consulta.messageType === '1' ? '1' : '2'
        consulta = {idReceptor: consulta.idReceptor, idLicitacion: consulta.idLicitacion, idMessage: consulta.idMessage, message: consulta.message, replyTo: consulta.replyTo, messageType: messageType}
        api.request('POST', 'api/generic/licitacionConsulta/' + consulta.idMessage, JSON.stringify(consulta))
        .then(() => {
          this.recargarDetalles()
        })
      },
      ordenarConsultas () {
        this.FAQ = this.licitacion.consultas.filter(el => el.messageType === '1')
        this.FAQ.forEach((el, index) => {
          this.FAQ[index].respuesta = this.licitacion.consultas.find(preg => preg.idMessage === el.replyTo)
          if (!this.FAQ[index].respuesta) {
            this.FAQ[index].respuesta = {message: ''}
          }
        })
        this.queries = this.licitacion.consultas.filter(el => el.messageType === '2')
        this.queries.forEach((el, index) => {
          this.queries[index].respuesta = this.licitacion.consultas.find(resp => resp.idMessage === el.replyTo)
          if (!this.queries[index].respuesta) {
            this.queries[index].respuesta = {message: ''}
          }
        })
      },
      guardarProveedores () {
        api.request('POST', 'api/guardarProveedoresLicitacion', {'idLicitacion': this.licitacion.idLicitacion, 'providers': this.providersSelected})
          .then(response => {
            this.showModalLicitacionProviders = false
            this.$parent.getLicitaciones()
            this.providersSelected = []
          })
      },
      invitarProviders () {
        let providers = ''
        this.providersSelected.forEach(provider => {
          providers += '<li>' + this.providers.find(unProvider => unProvider.idCompany === provider).companyName + '</li>'
        })
        //  this.providersSelected.forEach((provider, index) => {
          //  this.providersSelected[index] = parseInt(provider)
        //  })
        // this.providersSelected = this.providersSelected[0]
        this.$confirm('¿Realmente desea invitar a los proveedores seleccionados? Esta acción enviará correos a los proveedores y no permitirá cambiarlos <br /> <strong>Proveedores seleccionados:</strong>' + providers, 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false,
          dangerouslyUseHTMLString: true
        })
        .then(() => {
          api.request('POST', 'api/invitarProveedoresLicitacion', {'idLicitacion': this.licitacion.idLicitacion, 'providers': this.providersSelected})
          .then(response => {
            this.showModalLicitacionProviders = false
            this.$parent.getLicitaciones()
          })
        })
      },
      needProviders (row) {
        if (row) {
          return row.status.idLicitacionStatus === '1'
        } else {
          return false
        }
      },
      sendConsultaFrecuente () {
        if (this.newQuestion === '' || this.respuestaFrecuente === '') {
          this.$message({
            type: 'warning',
            message: 'Complete los campos vacios'
          })
          return
        }
        api.request('POST', 'api/generic/licitacionesConsulta', JSON.stringify({'idLicitacion': this.licitacion.idLicitacion, 'idEmisor': this.user.idUser, 'messageType': 0, 'idReceptor': '0', 'message': this.respuestaFrecuente, 'replyTo': null}))
        .then(response => {
          this.sendConsulta(response.data.idMessage, 0, 1)
          .then(response => {
            this.newQuestion = ''
            this.respuestaFrecuente = ''
            this.showModalFAQ = false
            this.$parent.getLicitaciones()
            this.recargarDetalles()
            this.ordenarConsultas()
          })
        })
      },
      sendConsulta (replyToId, idReceptor, messageType) {
        return new Promise((resolve, reject) => {
          if (this.newQuestion === '') {
            this.$message({
              type: 'warning',
              message: 'Complete los campos vacios'
            })
            return
          }
          api.request('POST', 'api/generic/licitacionesConsulta', JSON.stringify({'idLicitacion': this.licitacion.idLicitacion, 'idEmisor': this.user.idUser, 'messageType': messageType, 'idReceptor': idReceptor, 'message': this.newQuestion, 'replyTo': replyToId}))
          .then(response => {
            this.newQuestion = ''
            this.showModalFAQ = false
            this.$message({
              type: 'success',
              message: 'El mensaje ha sido enviado'
            })
            this.$parent.getLicitaciones()
            this.recargarDetalles()
            resolve(response.data)
          })
        })
      },
      sendAnswer (idMessage, idReceptor, message, consulta) {
        let that = this
        return new Promise((resolve, reject) => {
          if (message === '' || message === undefined) {
            that.$message({
              type: 'warning',
              message: 'La respuesta no puede estar vacia'
            })
            return
          }
          const respuesta = this.respuestas[idMessage]
          api.request('POST', 'api/generic/licitacionesConsulta', JSON.stringify({'idLicitacion': that.licitacion.idLicitacion, 'idEmisor': that.user.idUser, 'messageType': 0, 'idReceptor': idReceptor, 'message': respuesta, 'replyTo': null}))
          .then(response => {
            consulta = {idReceptor: consulta.idReceptor, idLicitacion: consulta.idLicitacion, idMessage: consulta.idMessage, message: consulta.message, replyTo: response.data.idMessage}
            api.request('POST', 'api/generic/licitacionConsulta/' + idMessage, JSON.stringify(consulta))
            this.$set(this.respuestas, idMessage, '')
            that.showModalFAQ = false
            that.$message({
              type: 'success',
              message: 'El mensaje ha sido enviado'
            })
            that.$parent.getLicitaciones()
            that.recargarDetalles()
            that.ordenarConsultas()
            resolve(response.data)
          })
        })
      },
      deleteLicitacionesConsulta (item) {
        this.$confirm('¿Está seguro que desea eliminar esta pregunta?', 'Atención', {
          confirmButtonText: 'Eliminar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        })
                .then(() => {
                  api.request('GET', 'api/deleteLicitacionesConsulta/' + item.idMessage)
                  .then(response => {
                    this.recargarDetalles()
                    if (response.data) {
                      this.$message({
                        type: 'success',
                        message: 'Se ha eliminado la pregunta'
                      })
                    } else {
                      this.$message({
                        type: 'warning',
                        message: 'No es posible eliminar la pregunta'
                      })
                    }
                  })
                })
      },
      uploadOfertas () {
        this.$confirm('¿Está seguro de subir estas ofertas?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          api.request('POST', 'api/generic/propuestas', JSON.stringify({'idLicitacion': this.licitacion.idLicitacion, 'idProvider': this.user.idProvider, 'oferta_tec': this.licitacion.oferta_tec, 'oferta_eco': this.licitacion.oferta_eco, 'status': 2}))
          .then(response => {
            this.$message.success('Se han subido las ofertas', 'success')
            this.$parent.getLicitaciones()
            this.needUpload = false
            this.canConfirm = true
          })
        })
        .catch(() => {
        })
      },
      confirmOfertas () {
        this.$confirm('¿Está seguro que desea confirmas las ofertas? Luego no se podrán modificar', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          api.request('POST', 'api/generic/licitacionProvider/' + this.licitacion.idLicitacionProvider, JSON.stringify({'status': 2}))
          .then(response => {
            this.$message.success('Se han subido las ofertas', 'success')
            this.$parent.getLicitaciones()
            this.showModalLicitacion = false
          })
        })
        .catch(() => {
        })
      },
      getRubros () {
        api.request('GET', 'api/generic/rubros')
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.error) {
            return
          }
          if (data) {
            this.rubros = data
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      },
      getBuyers () {
        api.request('GET', 'api/getUserWithJobs/1')
          .then(response => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              this.buyers = data
            }
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
      },
      getBoss () {
        api.request('GET', 'api/getUserWithJobs/2')
          .then(response => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              this.boss = data
            }
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
      },
      resetLicitacion () {
        this.editEco = false
        this.editTec = false
        this.needUpload = false
        this.licitacion = this.licitaciones.find(el => el.idLicitacion === this.licitacionNueva.idLicitacion)
        this.licitacionNueva.nombre = ''
        this.licitacionNueva.cuerpo = ''
        this.licitacionNueva.fecha_inicio = ''
        this.licitacionNueva.fecha_fin = ''
        this.licitacionNueva.supervisor = ''
        this.currentIdBuyer = []
        this.erroresLicitacion = []
        this.licitacionAlert = false
      },
      verificarLicitacion () {
        this.erroresLicitacion = []
        this.licitacionAlert = false
        if (this.licitacionNueva.nombre === '') {
          this.erroresLicitacion.push('Se requiere el nombre')
          this.licitacionAlert = true
        }
        if (this.licitacionNueva.cuerpo === '') {
          this.erroresLicitacion.push('Se requiere la descripción')
          this.licitacionAlert = true
        }
        if (this.licitacionNueva.fecha_inicio === '') {
          this.erroresLicitacion.push('Se requiere la fecha de inicio')
          this.licitacionAlert = true
        }
        if (this.licitacionNueva.fecha_fin === '') {
          this.erroresLicitacion.push('Se requiere la fecha de finalización')
          this.licitacionAlert = true
        }
        if (this.currentIdBuyer === '') {
          this.erroresLicitacion.push('Se requiereasignar a un comprador')
          this.licitacionAlert = true
        }
        if (this.licitacionAlert === true) {
          return false
        }
        return true
      },
      uploadInvoice () {
        /* this.$confirm('¿Realmente desea subir adjuntar esta factura?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          let formData = new FormData()
          formData.append('file', this.$refs.file.files[0])
          api.request('POST', 'api/generic/uploadInvoice/' + this.buyOrder.nic, formData)
          .then(response => {
            api.request('POST', 'api/generic/buyOrderHistory', JSON.stringify({ 'nic': this.buyOrder.nic, 'detalle': this.$store.state.countStatus[2].description, 'date': this.datetime() }))
            .then(response2 => {
              this.buyOrder.pdf = response.data.pdf
              this.$parent.getBuyOrders()
            })
          })
        }) */
      },
      guardarLicitacion () {
        if (this.editing) {
          if (this.verificarLicitacion()) {
            this.licitacionNueva.status = this.licitacionNueva.status.idLicitacionStatus
            api.request('POST', 'api/generic/licitaciones/' + this.licitacionNueva.idLicitacion, JSON.stringify(this.licitacionNueva))
              .then(response => {
                this.currentIdBuyer.forEach((item, index) => {
                  api.request('POST', 'api/generic/licitacionesCompradores', JSON.stringify({'idLicitacion': response.data.idLicitacion, 'idUser': item}))
                  .then(response => {
                  })
                })
                this.$message.success('Se ha modificado la compulsa', 'success')
                this.hideModal()
                this.$parent.getProviders()
              })
              .then(response => {
                this.$parent.getLicitaciones()
                this.$message.success('Se ha guardado la compulsa', 'success')
                this.hideModal()
              })
          }
          return
        }
        this.licitacionNueva.status = 1
        if (this.verificarLicitacion()) {
          delete (this.licitacionNueva.proveedores)
          api.request('POST', 'api/generic/licitaciones', JSON.stringify(this.licitacionNueva))
          .then(response => {
            this.currentIdBuyer.forEach((item, index) => {
              api.request('POST', 'api/createLicitacionesCompradores/', JSON.stringify({'idLicitacion': response.data.idLicitacion, 'idUser': item}))
              .then(response => {
                this.$message.success('Se ha agregado la nueva licitacion', 'success')
                this.hideModal()
                this.$parent.getLicitaciones()
              })
            })
          })
        }
      },
      seeDetails (row) {
        this.licitacion = JSON.parse(JSON.stringify(row))
        if (this.licitacion.status.idLicitacionStatus === '1') {
          this.licitacionNueva = JSON.parse(JSON.stringify(this.licitacion))
          this.currentIdBuyer = []
          if (this.licitacionNueva.buyers && this.licitacionNueva.buyers.length > 0) {
            this.licitacionNueva.buyers.forEach((item, index) => {
              this.currentIdBuyer.push(item.idUser)
            }
           )
          }
          this.showModal = true
          this.editing = true
          return
        }
        this.editing = false
        this.ordenarConsultas()
        if (this.user.isProvider) {
          this.clavarVistoCompulsa()
        }
        this.showModalLicitacion = true
        if (!this.user.isProvider) {
          this.offerAmount = this.licitacion.propuestas.filter(offer => offer.status === '2').length
        }
      },
      seeFAQ (row) {
        this.licitacion = row
        this.ordenarConsultas()
        this.showModalFAQ = true
      },
      seeProviders (row) {
        this.licitacion = row
        this.providersParaCompulsa = []
        this.providersSelected = []
        if (this.needProviders(this.licitacion)) {
          this.licitacion.proveedores.forEach((el, index) => { // this.licitaciones.providers
            this.providersSelected[index] = this.contacts.find(cont => cont.idProvider === el.idProvider).idCompany
            // this.providersSelected[index] = this.contacts.find(cont => cont.idProvider === el.idProvider).idCompany
          })
          this.providers.forEach((prov, index) => {
            if (this.contacts.some(cont => cont.idCompany === prov.idCompany)) {
              this.providersParaCompulsa.push(prov)
            }
          })
        } else {
          let i = 0
          this.licitacion.proveedores.forEach(el => {
            let prov = this.providers.find(prov => prov.idCompany === this.contacts.find(cont => cont.idProvider === el.idProvider).idCompany)
            if (this.providersParaCompulsa.indexOf(prov) === -1) {
              this.providersParaCompulsa[i++] = prov
            }
          })
        }
        this.showModalLicitacionProviders = true
      },
      cancelarLicitacion (row) {
        this.$confirm('¿Realmente desea cancelar la compulsa? Esta acción es irreversible', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          const date = new Date()
          const FormattedDate = date.toISOString().slice(0, 10)
          const data = {
            idLicitacion: row.idLicitacion,
            status: '4',
            fecha_fin: FormattedDate
          }
          api.request('POST', 'api/generic/licitaciones/' + row.idLicitacion, JSON.stringify(data))
          .then(response => {
            this.$parent.getLicitaciones()
          })
        })
      },
      borrarLicitacion (row) {
        this.$confirm('¿Realmente desea eliminar la compulsa? Esta acción es irreversible', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          const data = {
            idLicitacion: row.idLicitacion,
            status: '5'
          }
          api.request('POST', 'api/generic/licitaciones/' + row.idLicitacion, JSON.stringify(data))
          .then(response => {
            this.$parent.getLicitaciones()
          })
        })
      },
      clavarVistoCompulsa (idLicitacion) {
        if (this.user.isProvider && this.licitacion.visto === '0') {
          api.request('POST', 'api/generic/licitacionProvider/' + this.licitacion.idLicitacionProvider, {'idLicitacionProvider': this.licitacion.idLicitacionProvider, 'idLicitacion': this.licitacion.idLicitacion, 'idProvider': this.user.idProvider, 'status': '1'})
          .then(response => {
            this.$parent.getLicitaciones()
          })
        }
      },
      hideModal () {
        this.showModal = false
        this.resetLicitacion()
      },
      getProviders () {
        this.$store.commit('START_LOADING')
        api.request('GET', 'api/approvedListCompany')
        .then(response => {
          this.providers = response.data
          this.$store.commit('STOP_LOADING')
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('STOP_LOADING')
        })
      }
    },
    beforeMount () {
      // this.assignCompanyName()
      this.getBuyers()
      this.getBoss()
      this.getRubros()
      this.getLicitacionesStatus()
      this.getProviders()
      this.$parent.getLicitaciones()
    }
}
</script>

<style>
@media screen and (max-width: 992px) {
  .licitacion__input-mobile {
    display: none;
  }
  .licitacion__date-mobile input {
    width: 300px;
  }
  .licitacion__modal-mobile {
    width: 600px;
  }
  .licitacion__select-mobile input{
    width: 300px;
  }
  
  .provider__select-mobile input{
    width: 365px;
    margin-bottom: 10px;
  }

  .licitacion__buttons-mobile {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 50px;
  }

  .licitacion__button-mobile {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .licitacion__body-mobile-view {
    width: 250%;
    overflow: auto;
  }

  .licitaciones__table-mobile {
    overflow-x: hidden;
  }

}
  .datetime-picker input {
    height: 4em !important;
  }

  .el-dialog__body {
    overflow: auto;
    max-height: calc(100vh - 54px);
  }
  /* width */
::-webkit-scrollbar {
  width: 10px;

}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-tooltip__popper {
  transition-duration: 50ms;
  animation-duration: 1s;
}

button:enabled {
  cursor: pointer;
}

button:disabled {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// Licitaciones.vue?5b53f3d8